export default __webpack_public_path__ + "static/media/bazzle_vm_5.12a28471.png";